import React, { useEffect, useRef, useState } from 'react'
import ApexCharts from 'react-apexcharts';
import Select from 'react-select';
import { CallApi } from '../../../Components/common/CommonFunctions';
import { Link } from 'react-router-dom';

import { Container, Row, Col, Form, InputGroup, Button, ListGroup, Badge, Accordion, Modal, Offcanvas } from "react-bootstrap";
import { ReactComponent as Time } from "../../../assets/images/recovery_dahboard/time.svg";
import { ReactComponent as FilterIcon } from "../../../assets/images/icon_svg/filter.svg";
import { ReactComponent as DashBoardIcon } from "../../../assets/images/icon_svg/overview.svg";
import { ReactComponent as ReSize } from "../../../assets/images/icon_svg/resize.svg";
import { ReactComponent as FileUpload } from "../../../assets/images/icon_svg/fileupload.svg"; 
import { ReactComponent as Filter } from "../../../assets/images/icon_svg/new_filter.svg"; 
import { ReactComponent as Pices } from "../../../assets/images/icon_svg/pieceee.svg"; 
import { ReactComponent as Update } from "../../../assets/images/icon_svg/gray_updt.svg"; 
import { ReactComponent as Buffer } from "../../../assets/images/icon_svg/buffering.svg"; 
import { ReactComponent as Plus } from "../../../assets/images/icon_svg/plus.svg"; 
import { ReactComponent as Tick } from "../../../assets/images/icon_svg/tick.svg"; 
import { ReactComponent as BarChart } from "../../../assets/images/icon_svg/bar_chart.svg"; 
import { ReactComponent as LineChart } from "../../../assets/images/icon_svg/line_chart.svg";
import { ReactComponent as Map } from "../../../assets/images/icon_svg/map.svg";
import { ReactComponent as Reset } from "../../../assets/images/icon_svg/reopen_history.svg";
 
import { toast } from 'react-toastify';
import ManageDashboard from './Components/ManageDashboard'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import RegionChartDetails from './Components/RegionChartDetails';

const Charts = ({getDestination}) => {
    const defaultFilterData = {
        irregularity_type : [],
        recovery_phase : [],
        priority_type : [],
        reporting_station : [],
        error_station : []
    }

const defaultSelectedChanges = {
    created_at_from: '',
    created_at_to: '',
    closed_at_from: '',
    closed_at_to: '',
    irregularity_type: [],
    recovery_phase: [],
    priority_type: [],
    reporting_station: [],
    error_station: []
}

    const isMounted = useRef(false)
    const [appliedFilterCount, setAppliedFilterCount] = useState(0);
    const [chartData, setChartData] = useState();
    const initManage = localStorage.getItem('manageChart')
    const [manage, setManage] = useState(initManage || false);
    const [fullScreen, setFullScreen] = useState(false);
    const [regionChartData, setRegionChartData] = useState(null);
    const initOrg = ""
    const [filterRegion, setFilterRegion] = useState({
        region_name: "All regions",
        region_val: "general"
    })
    const isSmallScreen = window.innerWidth <= 1920;
    const [filter, setFilter] = useState(false);
    const [allRegions,setAllRegions] = useState([])
    const [moreFilterData,setMoreFilterData] = useState(defaultFilterData)
    const [selectedChanges, setSelectedChanges] = useState(defaultSelectedChanges)
    const [selectedRegion, setSelectedRegion] = useState({
        label: "General Overview",
        value: "general_overview"
    });

    const options = [
        { value: "general_overview", label: "General Overview" },
        { value: "region_summary", label: "Region Summary, Closed Cases" },
    ];

    const defaultChartOptions = (categories) => ({
        chart: {
            type: 'area',
            height: 350,
            toolbar: {
                show: false
            },
            zoom: {
                enabled: false
            },
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '55%',
                endingShape: 'rounded',
                borderRadius: 4,
                borderRadiusApplication: 'end',
                borderRadiusWhenStacked: 'last',
                dataLabels: {
                    position: 'top',
                },
            }
        },
        markers: {
            size: 4,
            strokeWidth: 2,
            strokeColors: "#1D4ED8"
        },
        dataLabels: {
            enabled: true,
            offsetY: -20,
            formatter: (val) => val,
            style: {
                fontSize: '12px',
                colors: ["#304758"]
            },
            background: {
                enabled: false
            }
        },
        stroke: {
            show: true,
            curve: 'smooth',
            width: 2,
            colors: ['#1D4ED8']
        },
        xaxis: {
            categories,
            labels: {
                style: {
                    fontSize: '12',
                    colors: ["#000"],
                    fontWeight: 600,
                }
            }
        },
        yaxis: {
            title: {
                text: ''
            },
            min: 0,
            // max: 500,
            // tickAmount: 5,
            labels: {
                formatter: (val) => Math.round(val),
            },
        },
        fill: {
            opacity: 1,
            colors: ["rgba(29, 78, 216, 0.80)"]
        },
        tooltip: {
            y: {
                formatter: (val) => val + " units"
            }
        }
    });

    const agingChartOptions = (categories) => ({
        ...defaultChartOptions(categories),
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '55%',
                borderRadius: 4,
                borderRadiusApplication: 'end',
                dataLabels: { position: 'top' },
                distributed: true,
            }
        },
        colors: ['#D3D3D3', '#FCD34D', '#FB923C', '#EF4444'],
        fill: {
            opacity: 1,
        },
        stroke: {
            show: false,
        },
        legend: { show: false },
    });

       const recoveryPhaseOptions = (categories) => ({
        ...defaultChartOptions(categories),
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '55%',
                borderRadius: 4,
                borderRadiusApplication: 'end',
                dataLabels: { position: 'top' },
                distributed: true,
            }
        },
        colors: ['#1D4ED8'],
        fill: {
            opacity: 1,
        },
        stroke: {
            show: false,
        },
        legend: { show: false },
    });


    const formatDate = (dateStr) => {
        const date = new Date(dateStr);

        return date.toLocaleDateString('en-GB', {
            day: 'numeric',
            month: 'long',
        });
    };

 const fetchAllRegions = () => {
        CallApi({
            endPoint: '/v2/service-recovery/dropdown-list',
            method: "GET",
            onSuccess: (res) => {
                if (res.data.response_code == 200) {
                    const resData = res?.data?.response_data?.region_list;
                    setAllRegions([{label: "All regions", value: "general"}, ...resData])
                    const moreFilterData = res?.data?.response_data;
                    setMoreFilterData(moreFilterData)
                } else {
                    toast.error(res.data.response_msg);
                }
            },
            onError: (msg) => toast.error(msg)
        });
    }

    const [agingOptions, setAgingOptions] = useState(agingChartOptions([]));
    const [agingSeries, setAgingSeries] = useState([{ name: '', data: [] }]);

    const [phaseOptions, setPhaseOptions] = useState(recoveryPhaseOptions([]));
    const [phaseSeries, setPhaseSeries] = useState([{ name: '', data: [] }]);

    const [trendOptions, setTrendOptions] = useState(defaultChartOptions([]));
    const [trendSeries, setTrendSeries] = useState([{ name: '', data: [] }]);

    const [openCaseSeries, setOpenCaseSeries] = useState([
        {
            name: '',
            data: [] 
        },
    ]);

const fetchKpiChartData = () => {

    setAgingSeries([{ name: '', data: [] }]);
    setPhaseSeries([{ name: '', data: [] }]);
    setTrendSeries([{ name: '', data: [] }]);

    setRegionChartData({
        discrepancies_segregation: [],
        error_station_distribution: [],
        discrepancies_time_frame: [],
    });

    const payload = {
        action: selectedRegion.value === "general_overview" ? "general" : "region",
        region: filterRegion.region_val === "general" ? "" : filterRegion.region_val,
    };

    CallApi({
        endPoint: '/v2/service-recovery/kpichart',
        payload,
        onSuccess: (res) => {
            if (res.data.response_code == 200) {
                const resData = res?.data?.response_data;

                // Always update both — so Region Summary has data on first load
                setRegionChartData(resData);
                setChartData(resData?.kpi);

                setAgingOptions(agingChartOptions(resData?.aging_distribution?.map(i => i.range) || []));
                setAgingSeries([{ name: 'Cases', data: resData?.aging_distribution?.map(i => i.count) || [] }]);

                setPhaseOptions(recoveryPhaseOptions(resData?.recovery_phase_distribution?.map(i => isSmallScreen ? i.phase.split(" ") : i.phase) || []));
                setPhaseSeries([{ name: 'Cases', data: resData?.recovery_phase_distribution?.map(i => i.count) || [] }]);

                setTrendOptions(defaultChartOptions(resData?.new_cases_trend_14_days?.map(i => formatDate(i.date)) || []));
                setTrendSeries([{ name: 'Cases', data: resData?.new_cases_trend_14_days?.map(i => i.count) || [] }]);
            } else {
                toast.error(res.data.response_msg);
            }
        },
        onError: (msg) => toast.error(msg)
    });
};

const handleFilterChart = (regName, regVal) => {
    setFilterRegion({
        region_name: regName,
        region_val: regVal,
    });
};

const handleMoreFilterChange = (field, value) => {
    if (typeof field === "object") {
        const { name, value: inputValue } = field.target;
        setSelectedChanges(prev => ({
            ...prev,
            [name]: inputValue,
        }));
    } else {
        setSelectedChanges(prev => ({
            ...prev,
            [field]: value,
        }));
    }
};

    const renderRegions = () => {
        return allRegions?.length > 0 && allRegions.map((region,index) => (
            <button onClick={() => handleFilterChart(region.label, region.value)} key={index} className={`chartNav ${region.value === filterRegion.region_val ? 'active' : ''}`}>
                {region.label}
            </button>
        ));
    };

    const goManage = () => {
        localStorage.setItem('manageChart', !manage)
        setManage(!manage)
    }

    const handleResetFilter = () => {
        setSelectedChanges(defaultSelectedChanges);
        setFilterRegion({
            region_name: "All regions",
            region_val: "general"
        })
        if (filterRegion.region_val === "general") {
            fetchKpiChartData();
        }
    }

    const toggleFullScreen = () => {
        setFullScreen(prev => !prev);
    };

    useEffect(() => {
        if (isMounted.current) return;
        fetchAllRegions()
        isMounted.current = true;
    }, [])

useEffect(() => {
    // setRegionChartData();
    fetchKpiChartData();
}, [filterRegion.region_val, selectedRegion.value]);

const handleChange = (selectedOption) => {
    setSelectedRegion(selectedOption);
};

    const handleApplyMoreFilters = () => {
        const payload = {
            action: selectedRegion.value === "general_overview" ? "general" : "region",
            region: filterRegion.region_val === "general" ? "" : filterRegion.region_val,
            created_at_from: selectedChanges.created_at_from,
            created_at_to: selectedChanges.created_at_to,
            closed_at_from: selectedChanges.closed_at_from,
            closed_at_to: selectedChanges.closed_at_to,
            irregularity_type: selectedChanges.irregularity_type.map(i => i.value),
            recovery_phase: selectedChanges.recovery_phase.map(i => i.value),
            priority: selectedChanges.priority_type.map(i => i.value),
            reporting_station: selectedChanges.reporting_station.map(i => i.value),
            error_station: selectedChanges.error_station.map(i => i.value),
        }
        CallApi({
            endPoint: '/v2/service-recovery/kpichart',
            payload,
            onSuccess: (res) => {
                if (res.data.response_code === 200) {
                    const resData = res?.data?.response_data;

                    setRegionChartData(resData);
                    setChartData(resData?.kpi);

                    setAgingOptions(
                        agingChartOptions(
                            resData?.aging_distribution?.map(i => i.range) || []
                        )
                    );
                    setAgingSeries([
                        {
                            name: "Cases",
                            data: resData?.aging_distribution?.map(i => i.count) || [],
                        },
                    ]);

                    setPhaseOptions(
                        recoveryPhaseOptions(
                            resData?.recovery_phase_distribution?.map(i =>
                                isSmallScreen ? i.phase.split(" ") : i.phase
                            ) || []
                        )
                    );
                    setPhaseSeries([
                        {
                            name: "Cases",
                            data:
                                resData?.recovery_phase_distribution?.map(i => i.count) || [],
                        },
                    ]);

                    setTrendOptions(
                        defaultChartOptions(
                            resData?.new_cases_trend_14_days?.map(i =>
                                formatDate(i.date)
                            ) || []
                        )
                    );
                    setTrendSeries([
                        {
                            name: "Cases",
                            data:
                                resData?.new_cases_trend_14_days?.map(i => i.count) || [],
                        },
                    ]);

                    setFilter(false);
                } else {
                    toast.error(res.data.response_msg);
                }
            },
            onError: (msg) => toast.error(msg)
        });
    }

    useEffect(() => {
        let count = 0;

        if (selectedChanges.created_at_from) count++;
        if (selectedChanges.created_at_to) count++;
        if (selectedChanges.closed_at_from) count++;
        if (selectedChanges.closed_at_to) count++;

        if (selectedChanges.irregularity_type.length) count++;
        if (selectedChanges.recovery_phase.length) count++;
        if (selectedChanges.priority_type.length) count++;
        if (selectedChanges.reporting_station.length) count++;
        if (selectedChanges.error_station.length) count++;

        setAppliedFilterCount(count);
    }, [selectedChanges]);

    return (
        <div className={`mainTab ${fullScreen ? 'fullscreen_slot' : ''}`}>
            {/* {manage ?
                <>
                    <span onClick={goManage} className='stk_back'> <FontAwesomeIcon icon={faArrowLeft} /> Back to kpi chart</span>
                    <ManageDashboard />
                </>
                : <> */}
            {/* <div className='d-flex align-items-center justify-content-between mb-3'>
                        <div className='d-flex align-items-center gap-2 chart_top'>
                            <h4 className='mb-0'>Dashboard</h4>
                            <Select
                                placeholder="Select Region"
                                className="chart_selct"
                                name="region_id"
                            />

                        </div>
                        <div>
                            <button variant="contained" className="filter" onClick={goManage}> Manage Dashboards </button>
                            <button variant="contained" className="filter"> <FilterIcon /> </button>
                        </div>
                    </div> */}

            <div className='d-flex align-items-center justify-content-between dashbord_top'>
                <div className='d-flex align-items-center gap-2'>
                    <h4 className='mb-0'><DashBoardIcon className='me-2' />Dashboard</h4>
                    <Select
                        options={options}
                        value={selectedRegion}
                        onChange={handleChange}
                        placeholder="General Overview"
                        className="chart_selct"
                        name="region_id"
                    />

                </div>
                <div className='d-flex align-items-center gap-2'>
                    <button className='fullscren_btn exportSvg'><FileUpload className='me-2' />Export</button>
                    <button onClick={toggleFullScreen} className='fullscren_btn'><ReSize className='me-2' />{`${fullScreen ? "Exit Fullscreen" : "Fullscreen"}`}</button>
                    {/* <button className='fullscren_btn exportSvg' onClick={() => setFilter(true)} ><Filter className='me-2' />Filters</button> */}
                </div>



            </div>

            <div className="d-flex gap-2 dashbord_bottom align-items-center">
                <span className='me-0 region_txt'><Map className='me-1'/>Region</span>
                {renderRegions()}
                <span className='me-0'><button onClick={()=> setFilter(true)} className='fullscren_btn exportSvg'><Filter className='me-2' />More filters</button></span>
                {/* {(filterRegion.region_val !== "general" || Object.values(selectedChanges).some(Boolean)) && <span onClick={handleResetFilter} className='me-0'><button className='reset_filter_btn'><Reset className='me-2' />Reset Filters</button></span>} */}
                {(filterRegion.region_val !== "general" || appliedFilterCount > 0) && (
                    <span onClick={handleResetFilter} className='me-0'>
                        <button className='reset_filter_btn'><Reset className='me-2' />Reset Filters</button>
                    </span>
                )}
            </div>

            <div className='main-content'>
                {selectedRegion.value === "region_summary" ?
                    <RegionChartDetails key={filterRegion.region_val} data={regionChartData} />
                    :
                    <>
                        <div className='d-flex gap-3 mb-3'>

                            <div className='chart_bg tw-20 h-100'>
                                <div className='d-flex align-items-center gap-2 border_icon_txt'>
                                    <Pices />
                                    <h3>Open Cases</h3>
                                </div>
                                <p className='gl_value'>{chartData?.open_cases || 0}</p>
                            </div>

                            <div className='chart_bg tw-22 h-100'>
                                <div className='d-flex align-items-center gap-2 border_icon_txt'>
                                    <Update />
                                    <h3>Average Case Age (open)</h3>
                                </div>
                                <p className='gl_value'>{chartData?.average_case_age || 0}</p>
                            </div>

                            <div className='chart_bg tw-20 h-100'>
                                <div className='d-flex align-items-center gap-2 border_icon_txt'>
                                    <Buffer />
                                    <h3>In Progress</h3>
                                </div>
                                <p className='gl_value'>{chartData?.recovery_phase || 0}</p>
                            </div>

                            <div className='chart_bg tw-20 h-100'>
                                <div className='d-flex align-items-center gap-2 border_icon_txt'>
                                    <Plus />
                                    <h3>New (24h)</h3>
                                </div>
                                <p className='gl_value'>{chartData?.new_cases_24h || 0}</p>
                            </div>

                            <div className='chart_bg tw-20 h-100'>
                                <div className='d-flex align-items-center gap-2 border_icon_txt'>
                                    <Plus />
                                    <h3>New (7d)</h3>
                                </div>
                                <p className='gl_value'>{chartData?.new_cases_7d || 0}</p>
                            </div>

                            <div className='chart_bg tw-20 h-100'>
                                <div className='d-flex align-items-center gap-2 border_icon_txt'>
                                    <Tick />
                                    <h3>Resolved (7d)</h3>
                                </div>
                                <p className='gl_value'>{chartData?.close_cases_7d || 0}</p>
                            </div>

                        </div>

                        <div className='d-flex gap-3 mb-3'>

                            <div className='global_roundbg tw-50'>
                                <div className='box_icon_text box_icon_text_two'>
                                    <span className='border_icon'><BarChart /></span>
                                    <h3>Aging Distribution – Open Cases</h3>
                                </div>
                                <ApexCharts
                                    key={`aging-${filterRegion.region_val}`}
                                    options={agingOptions}
                                    series={agingSeries}
                                    type="bar"
                                    height={318}
                                />

                            </div>
                            <div className='global_roundbg tw-50'>
                                <div className='box_icon_text box_icon_text_two'>
                                    <span className='border_icon'><BarChart /></span>
                                    <h3>Open Cases by Recovery Phase</h3>
                                </div>

                                <ApexCharts
                                    key={`phase-${filterRegion.region_val}`}
                                    options={phaseOptions}
                                    series={phaseSeries}
                                    type="bar"
                                    height={318}
                                />

                            </div>
                        </div>
                        <div className='global_roundbg'>
                            <div className='box_icon_text box_icon_text_two'>
                                <span className='border_icon'><LineChart /></span>
                                <h3>New Cases Trend (Last 14 Days)</h3>
                            </div>
                            <ApexCharts
                                key={`${selectedRegion.value}-${filterRegion.region_val}-${trendSeries[0]?.data?.join(",")}`}
                                options={trendOptions}
                                series={trendSeries}
                                type="area"
                                height={347}
                            />

                        </div>

                    </>

                }
                <Offcanvas
                    show={filter}
                    onHide={() => setFilter(false)}
                    placement="end"
                    className="filter-sidebar"
                >
                    <Offcanvas.Header closeButton>
                        <Offcanvas.Title>Filters</Offcanvas.Title>
                    </Offcanvas.Header>

                    <Offcanvas.Body>

                        <Accordion defaultActiveKey={["0", "1", "2", "3", "4"]} alwaysOpen>

                            {/* Created At */}
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>Created At</Accordion.Header>
                                <Accordion.Body>

                                    <Form.Group className="mb-3">
                                        <Form.Label>FROM</Form.Label>
                                        <Form.Control
                                        name='created_at_from'
                                        value = {selectedChanges.created_at_from}
                                        onChange={handleMoreFilterChange}
                                         type="date" />
                                    </Form.Group>

                                    <Form.Group>
                                        <Form.Label>TO</Form.Label>
                                        <Form.Control 
                                         name='created_at_to'
                                        value = {selectedChanges.created_at_to}
                                        onChange={handleMoreFilterChange}
                                        type="date" />
                                    </Form.Group>

                                </Accordion.Body>
                            </Accordion.Item>

                            {/* Closed At */}
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>Closed At</Accordion.Header>
                                <Accordion.Body>

                                    <Form.Group className="mb-3">
                                        <Form.Label>FROM</Form.Label>
                                        <Form.Control 
                                         name='closed_at_from'
                                        value = {selectedChanges.closed_at_from}
                                        onChange={handleMoreFilterChange}
                                        type="date" />
                                    </Form.Group>

                                    <Form.Group>
                                        <Form.Label>TO</Form.Label>
                                        <Form.Control 
                                        name='closed_at_to'
                                        value = {selectedChanges.closed_at_to}
                                        onChange={handleMoreFilterChange}
                                        type="date" />
                                    </Form.Group>

                                </Accordion.Body>
                            </Accordion.Item>

                            {/* Irregularity Type */}
                            {/* <Accordion.Item eventKey="2">
                                <Accordion.Header>Irregularity Type</Accordion.Header>
                                <Accordion.Body> */}
                                    <Form>
                                        <Select
                                            isMulti
                                            options={moreFilterData.irregularity_type}
                                            value={selectedChanges.irregularity_type}
                                            onChange={(selected) =>
                                                handleMoreFilterChange("irregularity_type", selected)
                                            }
                                            placeholder="Select Irregularity Type"
                                        />
                                    </Form>
{/* 
                                 </Accordion.Body>
                            </Accordion.Item> */}

                            {/* Recovery Phase */}
                            {/* <Accordion.Item eventKey="3">
                                <Accordion.Header>Recovery Phase</Accordion.Header>
                                <Accordion.Body> */}

                                    <Select
                                        isMulti
                                        options={moreFilterData.recovery_phase}
                                        value={selectedChanges.recovery_phase}
                                        onChange={(selected) =>
                                            handleMoreFilterChange("recovery_phase", selected)
                                        }
                                        placeholder="Select Recovery Phase"
/>

                                {/* </Accordion.Body>
                            </Accordion.Item> */}

                            {/* Priority */}
                            {/* <Accordion.Item eventKey="4">
                                <Accordion.Header>Priority</Accordion.Header>
                                <Accordion.Body> */}

                            <Select
                                isMulti
                                options={moreFilterData.priority_type}
                                value={selectedChanges.priority_type}
                                onChange={(selected) =>
                                    handleMoreFilterChange("priority_type", selected)
                                }
                                placeholder="Select Priority"
                            />

                                {/* </Accordion.Body>
                            </Accordion.Item> */}

                             {/* Reporting Station */}
                            {/* <Accordion.Item eventKey="5">
                                <Accordion.Header>Reporting Station</Accordion.Header>
                                <Accordion.Body> */}

                            <Select
                                isMulti
                                options={getDestination.map(item => ({
                                    value: item.label,
                                    label: item.label,
                                }))}
                                value={selectedChanges.reporting_station}
                                onChange={(selected) =>
                                    handleMoreFilterChange("reporting_station", selected)
                                }
                                placeholder="Select Reporting Station"
                            />

                                {/* </Accordion.Body>
                            </Accordion.Item> */}

                             {/* Error Station */}
                            {/* <Accordion.Item eventKey="6">
                                <Accordion.Header>Error Station</Accordion.Header>
                                <Accordion.Body> */}

                            <Select
                                isMulti
                                options={getDestination.map(item => ({
                                    value: item.label,
                                    label: item.label,
                                }))}
                                value={selectedChanges.error_station}
                                onChange={(selected) =>
                                    handleMoreFilterChange("error_station", selected)
                                }
                                placeholder="Select Error Station"
                            />

                                {/* </Accordion.Body>
                            </Accordion.Item> */}

                        </Accordion>

                    </Offcanvas.Body>

                    <div className="p-3 border-top">
                        <Button
                            onClick={handleApplyMoreFilters}
                            variant="none"
                            className="w-100 btn-dark"
                        >
                            Apply Filters ({appliedFilterCount})
                        </Button>
                    </div>

                </Offcanvas>
            </div>
        </div>
    )
}

export default Charts